import { UserSearchDto } from '../../users/shared/dto/user-search.dto';
import { PagedSearch } from 'src/app/shared';
import { SelectItem } from 'primeng/api';
import { UserService } from 'src/app/users/shared/user.service';
import { TaskSearchDto } from '../shared/dto/task-search.dto';
import { Component, OnInit, Output, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'wl-task-search-params',
  templateUrl: './task-search-params.component.html',
  styleUrls: ['./task-search-params.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TaskSearchParamsComponent implements OnInit {
  @Output() searchParamsChange = new EventEmitter<TaskSearchDto>();
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: TaskSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  assignedToUserItems: SelectItem[];

  private _searchParams: TaskSearchDto;
  constructor(private _userService: UserService) {
    this.searchParams = new TaskSearchDto();
  }

  ngOnInit(): void {
    const params = new UserSearchDto();
    params.PageSize = 0;
    this._userService.search(params).then((result) => {
      this.assignedToUserItems = result.Result?.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserNum };
      });
    });
  }
}
